module.exports = __webpack_public_path__ + "img/screen_2.9e05d2b8.svg";